import request from '../_helpers/request';

/**
 * 获取 ContactUs 查询原因下拉列表
 * @param {string} role - 'buyers' 或 'suppliers'
 * @returns {Promise}
 */
function GetReasons(role = 'buyers') {
  return request({
    url: 'ContactUs/GetReasons',
    method: 'get',
    params: {
      role: role
    }
  });
}

/**
 * 获取国家下拉列表
 * @param {number} langId - 语言ID: 936(简体), 950(繁体), 1252(英文)
 * @returns {Promise}
 */
function GetCountries(langId) {
  return request({
    url: 'ContactUs/GetCountries',
    method: 'get',
    params: {
      langId: langId
    }
  });
}

export const ContactUsService = {
  GetReasons,
  GetCountries
};

